module.exports = __webpack_public_path__ + "img/smilingFaces_logo.7cc37285.png";